import { render, staticRenderFns } from "./batchReceivableChange.vue?vue&type=template&id=6022e1f8&scoped=true"
import script from "./batchReceivableChange.vue?vue&type=script&lang=js"
export * from "./batchReceivableChange.vue?vue&type=script&lang=js"
import style0 from "./batchReceivableChange.vue?vue&type=style&index=0&id=6022e1f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022e1f8",
  null
  
)

export default component.exports